// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/mail-brand.svg';

export const MailBrand = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
